import Service from "./Service"

class SimpleInvoiceService extends Service {

    findById = (id) => this.get(`/simple-invoices/${id}`)

    findAll = (queryParams) => this.getWithParams("/simple-invoices", queryParams)

    getSenderOptions = () => this.get("/simple-invoices/senders")

    getReceiverOptions = () => this.get("/simple-invoices/receivers")

    togglePaid = (id, requestBody) => this.patch(`/simple-invoices/${id}/payment`, requestBody)

    deleteSimpleInvoice = (simpleInvoiceId) => this.del(`/simple-invoices/${simpleInvoiceId}`)
}

const simpleInvoiceService = new SimpleInvoiceService()
export default simpleInvoiceService